import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { ClassPickerService } from './class-picker-dialog/class-picker.service';
import { SelectedStudentService } from './selected-student.service';

/**
 * Ensures a student always has a valid enrollment selected before any portal
 * page activates. Without this, deep links / refreshes on non-home routes
 * could fire requests with no (or a stale) studentId.
 */
@Injectable({
  providedIn: 'root',
})
export class SelectedEnrollmentGuard {
  constructor(
    private _loginService: LoginService,
    private _selectedStudentService: SelectedStudentService,
    private _classPickerService: ClassPickerService,
  ) {}

  canActivateChild(): boolean | Promise<boolean> {
    // Non-students (and not-yet-recovered sessions) are AuthGuard's problem.
    if (!this._loginService.isLoggedIn || !this._loginService.hasInfo) {
      return true;
    }
    if (this._loginService.userInfo.type !== 'student') {
      return true;
    }
    if (this._selectedStudentService.hasSelection) {
      return true;
    }
    // Picking triggers a full reload via the class-switch overlay, so the
    // blocked navigation resolves itself after the user chooses.
    return this._classPickerService.open(true).then((picked) => picked != null);
  }
}
